import ToggleArea from './components/account/ToggleArea.vue';
import OptInBanner from './components/account/OptInBanner.vue';
import EmailVerificationBanner from './components/account/EmailVerificationBanner.vue';
import BannerCta from './components/account/BannerCTA.vue';
import HamburgerButton from './components/HamburgerButton';
import LazyBackground from './components/LazyBackground';
import { loader as loadComponents } from './components';

/**
 * Provide account specific components
 */
loadComponents({
    ToggleArea,
    OptInBanner,
    EmailVerificationBanner,
    BannerCta,
    HamburgerButton,
    LazyBackground,
});

// If we haven't loaded a specific page we'll fake the
// to avoid throwing an error
let LoadedPages = [];

if (Page.is('accountlandlordlistingsedit')) {
    LoadedPages.push(import('./pages/account/EditListing'));
}

if (Page.is('accountlandlorddashboard')) {
    LoadedPages.push(import('./pages/account/Listings'));
}

if (Page.is('accountlandlordbookings')) {
    LoadedPages.push(import('./pages/account/LandlordReservations'));
}

if (Page.is('accountlandlordpayments')) {
    LoadedPages.push(import('./pages/account/Payments'));
}

if (Page.is('accountlandlordtaxindex')) {
    LoadedPages.push(import('./pages/account/TaxInformation'));
}

if (Page.is('accounttenantpayment-methods')) {
    LoadedPages.push(import('./pages/account/PaymentMethods'));
}

if (Page.is('accounttenantyour-vehicles')) {
    LoadedPages.push(import('./pages/account/Vehicles'));
}

if (Page.is('accounttenantpromos')) {
    LoadedPages.push(import('./pages/account/PromoCodes'));
}

if (Page.is('accountwhitelabeledit')) {
    LoadedPages.push(import('./pages/account/Whitelabel'));
}

if (Page.in(['accountlandlordsecurity', 'accounttenantsecurity'])) {
    LoadedPages.push(import('./pages/account/Password'));
}

if (Page.in(['accountlandlordprofile', 'accounttenantprofile'])) {
    LoadedPages.push(import('./pages/account/ProfileDetails'));
}

if (Page.in(['accountlandlordtrust', 'accounttenanttrust'])) {
    LoadedPages.push(import('./pages/account/Trust'));
}

if (Page.in(['accountlandlordhelp', 'accounttenanthelp'])) {
    LoadedPages.push(import('./pages/account/Help'));
}

if (Page.is('accounttenantdashboard')) {
    LoadedPages.push(import('./pages/account/ActiveBookings'));
}

if (Page.is('accounttenantpast-reservations')) {
    LoadedPages.push(import('./pages/account/PastReservation'));
}

if (Page.in(['accounttenantbooking', 'accounttenantpast-reservationsbooking', 'accounttenantbookingfailed-payment'])) {
    LoadedPages.push(import('./pages/account/ManageBooking'));
}

if (Page.in('accounttenantauto-pay')) {
    LoadedPages.push(import('./pages/account/AutoPayPage'));
}

if (Page.in('accounttenantauto-payhonesty-mode')) {
    LoadedPages.push(import('./pages/account/AutoPayIncompleteSessionsPageComponents'));
}

if (Page.in('accountlandlordearnings')) {
    LoadedPages.push(import('./pages/account/SpaceOwnerEarnings'));
}

LoadedPages.push(...require('./frontend').default);

export default LoadedPages;
